module.exports = __webpack_public_path__ + "static/a42e16a2599f7dd56926c07354116c368dcbb3891fd4e5e58ed358db3c3563a4-24fc0b9770f5bb5582f2f6c19fb42245.png";